import React, { Component } from 'react';
import "./Readmore.scss"
import ShopsPopup from "../../../Helpers/Popup/ShopsPopup"
import { push } from '../../../Services/Analytics';

class Readmore extends Component {
    constructor(props) {
        super();
        this.handleClick = this.handleClick.bind(this);
        this.state = {};
    }
    handleClick() {
        push("Buy_online_clicked", "");
        this.props.togglePopup(<ShopsPopup />, "")
    }
    render() {
        return (
            <div className="readmore" onClick={this.handleClick}>
                <div className="rm-padding">
                    <div className="rm-container">
                        <div className="teaser">
                            <div className="text">
                            {this.props.teaserText}
                            </div>
                            <div className="button">
                                <div className="button-text">
                                    לחצו כאן
                                </div>
                            </div>
                        </div>
                        <div className="logospons"></div>
                        <div className="logo"></div>
                    </div>
                </div>
            </div>
        );
    }
}

export default Readmore;



// WEBPACK FOOTER //
// ./src/Components/Screens/5_Playbuzz/Readmore/Readmore.jsx